(function () {
  'use strict';

  var activeModal = null;
  var focusReturnElement = null;

  function formatMoney(cents) {
    var amount = Number(cents);
    var format = window.theme && window.theme.moneyFormat
      ? window.theme.moneyFormat
      : '${{amount}}';

    if (!Number.isFinite(amount)) {
      return '';
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);

    if (!match) {
      return '$' + (amount / 100).toFixed(2);
    }

    function formatWithDelimiters(value, precision, thousands, decimal) {
      var parts = (value / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

      return parts.length > 1 ? whole + decimal + parts[1] : whole;
    }

    var formattedAmount;

    switch (match[1]) {
      case 'amount_no_decimals':
        formattedAmount = formatWithDelimiters(amount, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formattedAmount = formatWithDelimiters(amount, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formattedAmount = formatWithDelimiters(amount, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formattedAmount = formatWithDelimiters(amount, 2, "'", '.');
        break;
      default:
        formattedAmount = formatWithDelimiters(amount, 2, ',', '.');
    }

    return format
      .replace(placeholderRegex, formattedAmount)
      .replace(/<[^>]*>/g, '')
      .trim();
  }

  function calculatePromotionalPrice(option) {
    var price = Number(option.price);
    var discountType = String(option.discountType || '').toLowerCase();
    var hasDiscountValue = option.discountValue !== null &&
      option.discountValue !== undefined &&
      option.discountValue !== '';
    var discountValue = hasDiscountValue ? Number(option.discountValue) : NaN;

    if (!Number.isFinite(price) || price < 0) {
      return null;
    }

    if (discountType === 'free') {
      return 0;
    }

    if (!Number.isFinite(discountValue) || discountValue < 0) {
      return null;
    }

    if (discountType === 'fixed_amount') {
      return Math.max(0, price - Math.round(discountValue * 100));
    }

    if (discountType === 'percentage' && discountValue <= 100) {
      return Math.max(0, Math.round(price * (100 - discountValue) / 100));
    }

    return null;
  }

  function buildPriceDisplay(option) {
    var price = Number(option.price);
    var promotionalPrice = calculatePromotionalPrice(option);

    if (!Number.isFinite(price) || price < 0) {
      return null;
    }

    var wrapper = document.createElement('span');
    var current = document.createElement('span');

    wrapper.className = 'pline-promo-option__pricing';
    current.className = promotionalPrice === null
      ? 'pline-promo-option__price'
      : 'pline-promo-option__price pline-promo-option__price--before';
    current.textContent = promotionalPrice === null
      ? 'Current price ' + formatMoney(price)
      : formatMoney(price);
    wrapper.appendChild(current);

    if (promotionalPrice !== null) {
      var after = document.createElement('span');

      after.className = 'pline-promo-option__price pline-promo-option__price--after';
      after.textContent = promotionalPrice === 0
        ? 'With promotion: Free'
        : 'With promotion: ' + formatMoney(promotionalPrice);
      wrapper.appendChild(after);
    }

    return wrapper;
  }

  function getRoute(name, fallback) {
    if (window.routes && window.routes[name]) {
      return window.routes[name];
    }

    return fallback;
  }

  function getCartAddUrl() {
    return getRoute('cartAddUrl', '/cart/add') + '.js';
  }

  function getCartUrl() {
    return getRoute('cartUrl', '/cart') + '.js';
  }

  function getCartChangeUrl() {
    return getRoute('cartChangeUrl', '/cart/change') + '.js';
  }

  function parsePromotionConfig(engineElement) {
    var script = engineElement.querySelector('[data-pline-promotion-config]');

    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('Promotion engine config could not be parsed.', error);
      return null;
    }
  }

  function findPromotionEngine(startElement) {
    if (startElement && startElement.querySelector) {
      var scopedEngine = startElement.querySelector('[data-pline-promotion-engine]');

      if (scopedEngine) {
        return scopedEngine;
      }
    }

    if (startElement && startElement.closest) {
      var closestEngine = startElement.closest('[data-pline-promotion-engine]');

      if (closestEngine) {
        return closestEngine;
      }
    }

    return document.querySelector('[data-pline-promotion-engine]');
  }

  function getGiftQuantityForPromotion(cart, promotionHandle) {
    return cart.items.reduce(function (quantity, item) {
      var properties = item.properties || {};

      if (properties._promotion_handle === promotionHandle) {
        return quantity + item.quantity;
      }

      return quantity;
    }, 0);
  }

  function shouldOpenPromotion(promotion) {
    var maxGifts = parseInt(promotion.maxGifts, 10) || 0;

    if (maxGifts <= 0) {
      return Promise.resolve(true);
    }

    return fetch(getCartUrl(), {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache'
      }
    }).then(function (response) {
      if (!response.ok) {
        return true;
      }

      return response.json().then(function (cart) {
        return getGiftQuantityForPromotion(cart, promotion.handle) < maxGifts;
      });
    }).catch(function () {
      return true;
    });
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        scrollToTop: false
      }
    }));
  }

  function closeModal() {
    if (!activeModal) {
      return;
    }

    document.documentElement.classList.remove('pline-promo-modal-open');
    document.removeEventListener('keydown', onKeydown);
    activeModal.parentNode.removeChild(activeModal);
    activeModal = null;

    if (focusReturnElement && focusReturnElement.focus) {
      focusReturnElement.focus();
    }

    focusReturnElement = null;
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  }

  function setModalStatus(modal, message, state) {
    var status = modal.querySelector('[data-pline-promo-status]');

    if (!status) {
      return;
    }

    status.textContent = message || '';
    status.setAttribute('data-state', state || '');
  }

  function addGiftToCart(promotion, option, qualifier, modal, button) {
    var originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';
    setModalStatus(modal, '', '');

    fetch(getCartAddUrl(), {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: option.variantId,
            quantity: 1,
            properties: {
              _promotion_handle: promotion.handle,
              _promotion_title: promotion.title,
              _promotion_gift: 'true',
              _promotion_max_gifts: String(promotion.maxGifts || 0),
              _qualifying_variant_id: qualifier.variantId ? String(qualifier.variantId) : '',
              _qualifying_product_title: qualifier.productTitle || ''
            }
          }
        ]
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (content) {
          throw new Error(content.description || 'The gift could not be added.');
        });
      }

      refreshCart();
      setModalStatus(modal, 'Your item was added to the cart.', 'success');

      window.setTimeout(function () {
        closeModal();
      }, 700);
    }).catch(function (error) {
      button.disabled = false;
      button.textContent = originalText;
      setModalStatus(modal, error.message || 'The gift could not be added. Please try again.', 'error');
    });
  }

  function buildOptionCard(promotion, option, qualifier, modal) {
    var card = document.createElement('article');
    var content = document.createElement('div');
    var label = document.createElement('span');
    var action = document.createElement('button');

    card.className = 'pline-promo-option';

    if (option.image) {
      var media = document.createElement('div');
      var image = document.createElement('img');

      media.className = 'pline-promo-option__media';
      image.className = 'pline-promo-option__image';
      image.src = option.image;
      image.alt = option.label;
      image.loading = 'lazy';
      media.appendChild(image);
      card.appendChild(media);
    }

    content.className = 'pline-promo-option__content';
    card.appendChild(content);

    label.className = 'pline-promo-option__label';
    label.textContent = option.label;
    content.appendChild(label);

    var priceDisplay = buildPriceDisplay(option);

    if (priceDisplay) {
      content.appendChild(priceDisplay);
    }

    action.type = 'button';
    action.className = 'pline-promo-option__action';
    action.textContent = option.available === false ? 'Unavailable' : promotion.actionLabel;
    action.disabled = option.available === false;
    content.appendChild(action);

    if (option.available !== false) {
      action.addEventListener('click', function () {
        addGiftToCart(promotion, option, qualifier, modal, action);
      });
    }

    return card;
  }

  window.PicturelinePromotionPricing = {
    calculatePromotionalPrice: calculatePromotionalPrice,
    formatMoney: formatMoney
  };

  function openPromotionModal(promotion, qualifier) {
    closeModal();

    focusReturnElement = document.activeElement;

    var modal = document.createElement('div');
    var backdrop = document.createElement('button');
    var dialog = document.createElement('div');
    var closeButton = document.createElement('button');
    var eyebrow = document.createElement('p');
    var title = document.createElement('h2');
    var body = document.createElement('p');
    var options = document.createElement('div');
    var status = document.createElement('p');

    modal.className = 'pline-promo-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'pline-promo-modal-title');

    backdrop.type = 'button';
    backdrop.className = 'pline-promo-modal__backdrop';
    backdrop.setAttribute('aria-label', 'Close promotion chooser');
    backdrop.addEventListener('click', closeModal);
    modal.appendChild(backdrop);

    dialog.className = 'pline-promo-modal__dialog';
    modal.appendChild(dialog);

    closeButton.type = 'button';
    closeButton.className = 'pline-promo-modal__close';
    closeButton.setAttribute('aria-label', 'Close promotion chooser');
    closeButton.innerHTML = '&times;';
    closeButton.addEventListener('click', closeModal);
    dialog.appendChild(closeButton);

    eyebrow.className = 'pline-promo-modal__eyebrow';
    eyebrow.textContent = promotion.title;
    dialog.appendChild(eyebrow);

    title.id = 'pline-promo-modal-title';
    title.className = 'pline-promo-modal__title';
    title.textContent = promotion.modalTitle || promotion.title;
    dialog.appendChild(title);

    if (promotion.modalBody) {
      body.className = 'pline-promo-modal__body';
      body.textContent = promotion.modalBody;
      dialog.appendChild(body);
    }

    options.className = 'pline-promo-options';
    promotion.giftOptions.forEach(function (option) {
      options.appendChild(buildOptionCard(promotion, option, qualifier, modal));
    });
    dialog.appendChild(options);

    if (promotion.disclaimer) {
      var disclaimer = document.createElement('p');
      disclaimer.className = 'pline-promo-modal__disclaimer';
      disclaimer.textContent = promotion.disclaimer;
      dialog.appendChild(disclaimer);
    }

    status.className = 'pline-promo-modal__status';
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('data-pline-promo-status', '');
    dialog.appendChild(status);

    document.body.appendChild(modal);
    document.documentElement.classList.add('pline-promo-modal-open');
    document.addEventListener('keydown', onKeydown);

    activeModal = modal;

    var firstAvailableOption = modal.querySelector('.pline-promo-option__action:not([disabled])');

    if (firstAvailableOption) {
      firstAvailableOption.focus();
    } else {
      closeButton.focus();
    }
  }

  function handleProductAdded(event) {
    var engineElement = findPromotionEngine(event.target);

    if (!engineElement) {
      return;
    }

    var config = parsePromotionConfig(engineElement);

    if (!config || !config.promotions || config.promotions.length === 0) {
      return;
    }

    var promotion = config.promotions.find(function (candidate) {
      return candidate.giftOptions && candidate.giftOptions.length > 0;
    });

    if (!promotion) {
      return;
    }

    var variant = event.detail && event.detail.variant ? event.detail.variant : null;
    var qualifier = {
      productId: config.productId,
      productTitle: config.productTitle,
      variantId: variant ? variant.id : null
    };

    shouldOpenPromotion(promotion).then(function (shouldOpen) {
      if (shouldOpen) {
        openPromotionModal(promotion, qualifier);
      }
    });
  }

  function handlePromotionOpen(event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('[data-pline-promotion-open]')
      : null;

    if (!trigger) {
      return;
    }

    var engineElement = findPromotionEngine(trigger);
    var config = parsePromotionConfig(engineElement);

    if (!config || !config.promotions || config.promotions.length === 0) {
      return;
    }

    var promotionHandle = trigger.getAttribute('data-pline-promotion-open');
    var promotion = config.promotions.find(function (candidate) {
      return candidate.handle === promotionHandle && candidate.giftOptions && candidate.giftOptions.length > 0;
    });

    if (!promotion) {
      return;
    }

    openPromotionModal(promotion, {
      productId: config.productId,
      productTitle: config.productTitle,
      variantId: null
    });
  }

  document.addEventListener('product:added', handleProductAdded);
  document.addEventListener('click', handlePromotionOpen);

  window.PicturelinePromotionEngine = {
    refreshCart: refreshCart,
    closeModal: closeModal
  };
})();
